import React from 'react';
import { motion } from 'framer-motion';
import { Search, Target, ShieldCheck, Lock, TrendingUp } from 'lucide-react';

const PentestWhy = () => {
  const reasons = [
    {
      title: "Identifier les vulnérabilités",
      icon: <Search size={18} />,
      desc: "Détection approfondie des failles critiques et des erreurs de configuration au sein de votre infrastructure réseau et applicative.",
    },
    {
      title: "Anticiper les cyberattaques",
      icon: <Target size={18} />,
      desc: "Simulation de scénarios d'attaques sophistiquées pour comprendre comment un pirate pourrait contourner vos défenses.",
    },
    {
      title: "Renforcer les systèmes",
      icon: <ShieldCheck size={18} />,
      desc: "Mise en place de correctifs ciblés et optimisation continue des configurations pour durcir votre périmètre.",
    },
    {
      title: "Protéger les données",
      icon: <Lock size={18} />,
      desc: "Garantie de la confidentialité et de l'intégrité de vos actifs numériques et des données de vos clients.",
    },
    {
      title: "Améliorer la posture globale",
      icon: <TrendingUp size={18} />,
      desc: "Évaluation stratégique complète pour aligner vos investissements en cybersécurité avec les menaces réelles.",
    }
  ];

  return (
    // ✅ Removed px-6, flex justify-center, max-w — full bleed background
    <section className="w-full bg-[#f8fafc] py-12 lg:py-16 font-inter">
      <div className="px-12">

        {/* HEADER SECTION */}
        <div className="mb-10 text-left">
          <div className="inline-block px-2.5 py-0.5 rounded-full bg-[#E0F2FE] mb-4">
            <span className="text-[#3b82f6] text-[9px] font-black uppercase tracking-wider">
              Sécurité Offensive
            </span>
          </div>
          <h2 className="text-[#0f172a] text-[32px] lg:text-[38px] font-[900] leading-tight mb-4 tracking-tight">
            Pourquoi réaliser un <br className="hidden lg:block" /> pentest ?
          </h2>
          <p className="text-[#64748b] text-[14px] lg:text-[15px] leading-relaxed max-w-[580px] font-medium opacity-90">
            L'audit d'intrusion est une étape cruciale pour garantir la résilience de votre infrastructure face aux acteurs malveillants.
          </p>
        </div>

        {/* GRID DES RAISONS */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((reason, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, x: -15 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: idx * 0.08, duration: 0.4 }}
              whileHover={{ 
                y: -5,
                backgroundColor: "rgba(255, 255, 255, 1)",
                borderColor: "#3b82f6"
              }}
              className={`relative group p-6 bg-white rounded-2xl border border-slate-100 shadow-sm flex flex-col items-start transition-all duration-300 ${
                idx === 4 ? "lg:col-span-2" : ""
              }`}
            >
              {/* Barre de scan latérale */}
              <motion.div 
                initial={{ height: 0 }}
                whileInView={{ height: "30%" }}
                transition={{ duration: 0.8, delay: 0.4 }}
                className="absolute left-0 top-1/4 w-1 bg-[#3b82f6] rounded-r-full"
              />

              {/* Icon Box */}
              <div className="bg-[#E0F2FE] text-[#3b82f6] p-2.5 rounded-lg mb-5 group-hover:bg-[#3b82f6] group-hover:text-white transition-colors duration-300">
                {reason.icon}
              </div>

              <h3 className="text-[#0f172a] text-[17px] font-black mb-3 group-hover:text-[#3b82f6] transition-colors">
                {reason.title}
              </h3>

              <p className="text-slate-500 text-[12.5px] leading-relaxed font-medium">
                {reason.desc}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PentestWhy;